export default "__VITE_ASSET__eNoD2fzo__"